import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';
import clsx from 'clsx';
import { MessageFile } from '@shared/api';
import { Attachment } from '../../shared/widgets/attachment';

const useStyles = makeStyles<Theme>(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    listStyleType: 'none',
    padding: 0,
    gap: '5px',
  },
}));

const isSystemFile = (source: unknown): source is File => source instanceof File;

const convert = (source: MessageFile | File) => {
  if (isSystemFile(source)) {
    return {
      filename: source.name,
      fileSizeBytes: source.size,
    } as MessageFile;
  } else return source as MessageFile;
};

interface AttachmentsProps {
  className?: string;
  mode?: 'upload';
  items: (MessageFile | File)[];
  onDelete?: (i: number) => unknown;
  onDownload?: (id: string, filename?: string) => unknown;
  onRemoteDelete?: (id: string) => unknown;
}

export const Attachments = (props: AttachmentsProps) => {
  const styles = useStyles();

  return (
    <ul className={clsx(styles.container, props.className)}>
      {props.items.map((file, idx) => {
        const item = convert(file);
        return (
          <Attachment
            key={idx}
            mode={props.mode}
            filename={item.filename}
            size={item.fileSizeBytes}
            onDelete={props.onDelete ? () => props.onDelete?.(idx) : props.onRemoteDelete ? () => props.onRemoteDelete?.(item.id) : undefined}
            onDownload={props.onDownload ? () => props.onDownload?.(item.id, item.filename) : undefined}
          />
        );
      })}
    </ul>
  );
};
